window.ajaxError = function (xhr, validation_callback) {
    switch (xhr.status) {
        case 401:
            window.location.href = '/';
            break;
        case 403:
            toastAlert('권한이 없습니다.');
            break;
        case 419:
            window.location.reload();
            break;
        case 422:
            if (!isEmpty(xhr.responseJSON) && !isEmpty(xhr.responseJSON.errors)) {
                consoleLog(xhr.responseJSON.errors);
                if (typeof validation_callback !== 'undefined') {
                    validation_callback(xhr.responseJSON.errors);
                } else {
                    //toastAlert(xhr.responseJSON.errors[(Object.keys(xhr.responseJSON.errors)[0])][0], 'error');
                    toastAlert(Object.entries(xhr.responseJSON.errors)[0][1], 'error');
                }
                //
                // if ($('.' + Object.keys(xhr.responseJSON.errors)[0] + '_error').length > 0) {
                //     $(".error_message").addClass('d-none');
                //     $("." + Object.keys(xhr.responseJSON.errors)[0] + '_error_message').html(xhr.responseJSON.errors[(Object.keys(xhr.responseJSON.errors)[0])][0]);
                //     $("." + Object.keys(xhr.responseJSON.errors)[0] + '_error').removeClass('d-none');
                // } else {
                //     toastAlert(xhr.responseJSON.errors[(Object.keys(xhr.responseJSON.errors)[0])][0], 'error');
                // }
            }
            break;
    }
    consoleLog('ajaxError: ' + xhr.status);
};

window.ajaxComplete = function (xhr) {

    loading('OFF');

    if (isEmpty(xhr)) {
        return false;
    }

    if (xhr.status === 200) {
        if (isEmpty(xhr.responseJSON)) {
            return false;
        }
        consoleLog(xhr.responseJSON);
        if (isEmpty(xhr.responseJSON.resultType)) {
            return false;
        }

        if (!isEmpty(xhr.responseJSON.unread_count)) {
            setUnreadCount(xhr.responseJSON.unread_count);
        }
        toastAlert(xhr.responseJSON.message, xhr.responseJSON.resultType);
    }
};

window.setErrorMessage = function(element, errors) {
    element.removeClass('d-none').children('.col').html(Object.entries(errors)[0][1]);
};

window.selectTab = function (tab_id) {
    $(".tabs").removeClass("active");
    $("#" + tab_id).addClass("active");
    AJAX_RELOAD = function() {
        $("#" + tab_id).trigger("click");
    };
    consoleLog(typeof(AJAX_RELOAD));
};

window.disableBackButton = function () {
    if($('body').hasClass('modal-open')) {
        $('.modal').modal('hide');
    } else {
        history.pushState(null, null, document.URL);
        closePopupContent();
    }
};

window.openPopupContent = function () {
    history.pushState(null, null, document.URL);
    window.addEventListener('popstate', disableBackButton);
    ORG_SCROLL_POSITION = window.pageYOffset || document.documentElement.scrollTop;
    $("#app").addClass("d-none");
    $("#popup_content").removeClass("d-none");
    $(window).scrollTop(0);
};
window.closePopupContent = function () {
    window.removeEventListener('popstate', disableBackButton);
    $("#popup_content").addClass("d-none");
    $("#app").removeClass("d-none");
    $(window).scrollTop(ORG_SCROLL_POSITION);
};

// window.setFavoriteIcon = function (uuid, is_favorite) {
//     if (is_favorite) {
//         $("#popup_menu_favorite").html('<i class="fas fa-heart pointer text-white" onClick="setFavorite(\'' + uuid + '\', false);"></i>');
//     } else {
//         $("#popup_menu_favorite").html('<i class="far fa-heart pointer text-white" onClick="setFavorite(\'' + uuid + '\', true);"></i>');
//     }
// };
//
// window.setFavorite = function (uuid, is_add) {
//     ajaxCall('/favorites/set_favorite', 'uuid=' + uuid + '&is_add=' + is_add, function (json) {
//         if (json.resultType !== 'success') return false;
//         setFavoriteIcon(json.result.uuid, json.result.is_favorite_user);
//     });
// };

window.checkItem = function (item_code, callback) {
    ajaxCall('/item/check_item', 'item_code=' + item_code, callback);
};

window.setUnreadCount = function (unread_count) {
    $(".badge_unread_alarm_count").html(zeroToBlank(unread_count.alarm));
    if (unread_count.alarm > 0) {
        $(".btn_alarm").addClass("active");
    } else {
        $(".btn_alarm").removeClass("active");
    }
    $(".badge_profile_unread_count").html(zeroToBlank(unread_count.profile));
    $(".badge_note_unread_count").html(zeroToBlank(unread_count.note));
    $(".badge_chat_unread_count").html(zeroToBlank(unread_count.chat));
    $(".badge_chat_note_unread_count").html(zeroToBlank(unread_count.chat + unread_count.note));
};

// window.getIconSrc = function (icon_src, gender) {
//     return isEmpty(icon_src) ? CDN + '/' + PROJECT + '/images/common/' + 'photo_none_' + gender + '.png' : CDN + '/' + icon_src;
// };

window.getItemUnit = function(item_type) {
    return item_type === 'PERIOD' ? '일' : '개';
};

/* hybrid.js call */
window.resultGoogleInappBillingConsume = function (json) {};
window.resultOnestoreInappBillingConsume = function (json) {};
window.openModalPaymentProcessing = function () {
    openModalAlert('PAYMENT_PROCESSING');
};